import { uuidBase62 } from '@dreamworld/uuid-base62';
class EntityIdProvider {
  static getId() {
    return uuidBase62();
  }
}

export const entityIdProvider = EntityIdProvider;
export default entityIdProvider;
